<script setup>
import { computed, ref} from 'vue'
import {useStore} from "vuex"
const KONKOORI_LINK ='/courses?courses=&grades=2&lessons=&professors=&fields=&is_free=false'
const store = useStore()
import { onClickOutside } from '@vueuse/core'
const navigation = ref(null)
onClickOutside(navigation, () => {
  store.dispatch('mobileMenu/closeMenu')
})
const CLOSE = false
const OPEN = true
const menuStatus = computed(() => store.getters['mobileMenu/menu'])
const changeStateMobileDrawer = (status) => {
  if (status) {
    store.dispatch('mobileMenu/openMenu')
  } else {
    store.dispatch('mobileMenu/closeMenu')
  }
}
</script>
<template>
  <v-layout v-if="$vuetify.display.mdAndDown">
    <v-navigation-drawer permanent persistent ref="navigation" :width="310" class="cl-menu-mobile" v-model="menuStatus" color="#F5F8FF">
      <v-list lines="one" role="menu" class="px-3">
        <v-list-item height="15px" @click="changeStateMobileDrawer(CLOSE)" role="menuitem">
          <v-icon icon="$mdiArrowRight"></v-icon>
          <span class="mr-2">
             منو
          </span>
        </v-list-item>
        <v-list-item height="15px"  role="menuitem">
          <router-link :to="{name:'courses' , query: {grades: 2}}" class="text-black" @click="changeStateMobileDrawer(CLOSE)"> کنکوری‌ها</router-link>
        </v-list-item>
        <v-list-item height="15px"  role="menuitem">
          <router-link :to="{name:'talentedStudents'}" class="text-black" @click="changeStateMobileDrawer(CLOSE)">تیزهوشان</router-link>
        </v-list-item>
        <v-list-group value="Admin">
          <template v-slot:activator="{ props }">
            <v-list-item
              rounded="xl"
              @click="changeStateMobileDrawer(OPEN)"
              v-bind="props"
              color="primary"
              title="استادینو"
            ></v-list-item>
          </template>
          <v-list-item
            color="primary"
            rounded="xl"
            height="15px"
            class="text-decoration-none mt-1"
            width="100%"
            :to="{name:'ostadino'}"
            @click="changeStateMobileDrawer(CLOSE)">
            مشاهده مسابقه
          </v-list-item>
          <v-list-item
            color="primary"
            rounded="xl"
            height="15px"
            class="text-decoration-none mt-1"
            width="100%"
            :to="{name:'ostadino_policy'}"
            @click="changeStateMobileDrawer(CLOSE)">
            قوانین و شرکت در مسابقه
          </v-list-item>
        </v-list-group>
        <v-list-item height="15px"  role="menuitem">
          <router-link :to="{name:'faq'}" class="text-black" @click="changeStateMobileDrawer(CLOSE)">سوالات متداول</router-link>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </v-layout>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.cl-menu-mobile {
  border-radius: 24px 0 0 24px;
}
</style>

